import React from 'react';
import { StoryPath } from './StoryPath';

/**
 * Story page body.
 *
 * Mid-rework: the aim/kitchen beat rows and the "Where we're going" vision
 * section were cut, leaving hero -> grounded -> what's next. Replaces the
 * old past-tense StorySection timeline.
 */

const RECIPES_HREF = '#recipes';

export function StoryOverlay() {
  return (
    <>
      <header className="story-hero">
        <div className="story-wrap">
          <p className="story-kicker">Denver, Colorado</p>
          <h1>The TrueNooch Story</h1>
          <p className="story-lede">
            TrueNooch is grounded in two rooms. Triathlon training, where what you want is balanced
            macros and no mental overhead. And a yoga resort kitchen, where catering to allergens,
            vegetarian and vegan diets is a priority.
          </p>
        </div>
      </header>

      <section className="story-origin fade-in">
        <div className="story-wrap">
          <div>
            <p className="story-kicker">Where we are grounded</p>
            <img
              className="story-origin-img"
              src={`${process.env.PUBLIC_URL}/images/product/truenooch-ingredients.webp`}
              alt="The eight raw ingredients in TrueNooch laid out on a wooden board — nutritional yeast, red lentils, tri-color quinoa, kidney beans, aquafaba, avocado oil, coconut sugar, sea salt."
              loading="lazy"
            />
            <p className="story-origin-cap">Eight vegan ingredients, everything comes from here.</p>
          </div>
          <div>
            <p className="story-pull">TrueNooch’s core foundation</p>
            <p>
              To create food with whole ingredients that can act as a base for a diversity of
              diets.
            </p>
          </div>
        </div>
      </section>

      <StoryPath />

      <section className="story-close fade-in">
        <div className="story-wrap">
          <p className="story-kicker">What’s next</p>
          <h2>We’re still cooking.</h2>
          <p>
            Explore the{' '}
            <a className="story-link" href={RECIPES_HREF}>
              recipes
            </a>{' '}
            we have been enjoying.
          </p>
        </div>
      </section>
    </>
  );
}
